__turbopack_context__.v({
  "inlineEditFieldOptional": "form-module__AXyD7G__inlineEditFieldOptional",
  "inlineLabelError": "form-module__AXyD7G__inlineLabelError",
  "modalDivider": "form-module__AXyD7G__modalDivider",
  "modalField": "form-module__AXyD7G__modalField",
  "modalForm": "form-module__AXyD7G__modalForm",
  "modalGrid": "form-module__AXyD7G__modalGrid",
  "modalInput": "form-module__AXyD7G__modalInput",
  "modalLabel": "form-module__AXyD7G__modalLabel",
  "visibilityActionBtn": "form-module__AXyD7G__visibilityActionBtn",
  "visibilityPrivateBtn": "form-module__AXyD7G__visibilityPrivateBtn",
  "visibilityPublicBtn": "form-module__AXyD7G__visibilityPublicBtn",
});
